module.exports = __webpack_public_path__ + "static/media/6_pin_din.1da7aecd.png";